import { forwardRef } from "react";

const AdminFormInput = forwardRef(function AdminFormInput(
  { label, hint, className = "", ...props },
  ref
) {
  return (
    <div className={className}>
      {label && (
        <label className="block text-xs font-semibold uppercase tracking-wider text-slate-500 mb-1.5">
          {label}
        </label>
      )}
      <input
        ref={ref}
        {...props}
        className="w-full bg-white border border-slate-300 focus:border-indigo-500 focus:ring-2 focus:ring-indigo-500/20 focus:outline-none rounded-lg px-3 py-2.5 text-sm text-slate-900 placeholder:text-slate-400 transition-colors"
      />
      {hint && <p className="text-xs text-slate-400 mt-1">{hint}</p>}
    </div>
  );
});

export default AdminFormInput;
